import React, { useState, useEffect } from "react";
import "./Floaticons.css";
import Feedback from "./Feedback";
import RaiseRequest from "./RaiseRequest";
import Modal from "react-modal";
import TestimonialContent from "../function-components/TestimonialContent";
function Floaticons() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="float-wrap">
        <Feedback />
        <RaiseRequest />
        <div className="float-box box2">
          <p>
            <a href="mailto:L-TT_ATCGNtraining">
              <img
                src="images/Home/Contact-us-latest.png"
                alt="icons"
                className="float-icons"
              />
              Contact us
            </a>
          </p>
        </div>
        <div className="float-box box3">
          <p>
            <a onClick={handleOpenModal}>
              <img
                src="images/Home/testimonial_hanging_menu.png"
                alt="icons"
                className="float-icons testimonials"
              />
              ATCGN Testimonials
            </a>
          </p>
        </div>
        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          contentLabel="Testimonials"
          className="testimonial-modal"
          overlayClassName="testimonial-overlay"
        >
          <button className="close-btn-modal" onClick={handleCloseModal}>
            &times;
          </button>
          <div className="testimonial-sec-container">
            <div className="testimonial-sec-wrap">
              <h2 className="main-headings">ATCGN Testimonials</h2>
              <TestimonialContent />
            </div>
          </div>
        </Modal>
        {/* <div className="float-box box3">
          <p>
            <a
              href="https://engage.cloud.microsoft/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMzQ0NTY4NyJ9/new?domainRedirect=true"
              target="_blank"
            >
              <img
                src="images/Home/VivaEngage.png"
                alt="icons"
                className="float-icons three"
              />
              Viva Engage
            </a>
          </p>
        </div> */}
      </div>
    </>
  );
}

export default Floaticons;
